import {
  concat,
  countBy,
} from "lodash";

export default {
  system: {
    title:
      "上海晓隆科技有限公司-晓隆科技-汽车后市场智慧供应链服务平台-正品汽车零部件流通服务平台",
    home: {
      // header
      concact: {
        em: "登录",
      },
      // meau
      menu: {
        home: "首页",
        Product_Center:
          "产品中心",
        product1: "产品1",
        product2: "产品2",
        product3: "产品3",
        product4: "产品4",
        product5: "产品5",
        product6: "产品6",
        product7: "产品7",
        aboutUs: "关于我们",
        companyIntroduction:
          "公司简介",
        qualityControl:
          "质量控制",
        news: "新闻中心",
        mediaCenter:
          "媒体中心",
        contactUs: "联系我们",
        contactWay:
          "联系方式",
        register: "注册",
        talentPlan:
          "人才计划",
        efficient: "高效运营",
        digital: "数字化服务",
        marketing: "营销支持",
        partner: "伙伴关系",
        social: "社会责任",
        // 其他菜单项...
      },
      // product
      product: {
        chanpin: "产品名称:",
        oE: "OE号:",
        pinpai: "品牌:",
        chexing: "类别:",
        carType: "适用型号:",
      },
      //lunbo
      p_t: "专业服务，客户至上",
      placeholder:
        "请输入产品名称......",
      w_z_t: "观看完整版",
      text: "搜索和创建你的Xiao Long配件目录",
      // --q_o
      a_t_o:
        "在魔都上海嘉定区同济汽车产业园，上海晓隆科技有限公司熠熠生辉。公司致⼒于打造国内领先的汽车后市场服务平台，以客户为中⼼，以数字化销售能⼒为引领，以智慧 AI 商业运营平台为依托，专注于研发汽配交易及互联网电子商务技术服务。",
      a_t_t:
        "凭借深厚的专业知识和创新精神，晓隆科技以技术件为切入点，成功整合产业链上下游优质资源，与核心 TIER 1 工厂及主机⼚建立了紧密的合作关系。公司已建立线上自营商城，线下拥有 3 万余家经销商客户，其中固定活跃经销商客户多达 1600 余家，业务覆盖全国各地。",
      a_t_p:
        "晓隆科技将线上线下相结合，为国内汽车后市场全渠道客户提供优质服务，以创新的商业模式和强大的运营能力，为企业的发展注入新动力。",
      a_t_q:
        "未来，晓隆科技将继续秉持“科技驱动、创新引领、客户至上”的理念，不断优化平台功能和服务体验，为推动汽车后市场行业的数字化转型和高质量发展贡献力量，向着“打造人人离不开的汽车后市场服务平台”的愿景稳步迈进。",
      g_d: "更多",
      v_t: " 上海晓隆科技有限公司为上海市专精特新企业，全资子公司上海汽车配件工业联合有限公司为上海市高新技术企业，成立于1993年，深耕中国汽车产业后市场30余年，是中国汽车后市场标杆企业。晓隆科技目前与超过100家OEM和TIER1生产商建立战略合作，为您提供包括上汽大众、上汽通用、上汽乘用车、奇瑞商用车等十余家主机厂售后一体化汽车零部件供应解决方案。",
      // mask
      hlp_title: "华联配",
      brand_title: "品牌配套",
      des_t:
        // "安摩斯Amoser 正时系统专业品牌",
        "科技驱动、创新引领、客户至上",
      des_b:
        // " 中亿 以高质量的产品服务客户",
        "科技驱动、创新引领、客户至上",
      // dongtu
      tu_yc: {
        o_a: "原厂件",
        o_b: "原厂件",
      },
      tu_sj: {
        o_a: "车灯",
        o_b: "逐梦智慧之光，照亮精彩出行",
      },
      tu_o: {
        o_a: "发动机",
        o_b: "发动机是技术的杰作，是创新和坚韧的结晶",
      },
      tu_t: {
        o_a: "空调压缩机",
        o_b: "强悍耐用的“芯”，经得起时间的考验",
      },
      tu_th: {
        o_a: "电子扇",
        o_b: "让天地清爽,清爽天地间",
      },
      tu_qr: {
        o_a: "发动机",
        o_b: "发动机是技术的杰作，是创新和坚韧的结晶",
      },
      // tu_f: {
      //   o_a: "大陆燃油泵",
      //   o_b: "动力源于科技,好泵成就梦想",
      // },
      // tu_fi: {
      //   o_a: "博格华纳增压器",
      //   o_b: "涡轮增压，动力十足，驾驶更轻松",
      // },
      //--zhiliang
      m_p: " 晓隆科技以质量为品牌生命，这就意味着我们总能以最高的产品质量为您提供服务并完全保障您的市场声誉同时我们承诺晓隆合作品牌所提供的产品均通过国际安全与质量认证,最长质保期可达4年。",
      //--cp
      inner_1: "04-02.2024",
      inner_2: "03-28,2024",
      inner_3: "03-26,2024",
      jq: "进气歧管的作用是什么？",
      qj: "汽车前减平面轴承是什么？",
      ry: "燃油泵总成作用有哪些？",
      // --yq
      you_qing: "友情链接",
      lianjie: {
        text_a: "产品中心",
        text_news: "新闻中心",
        text_b: "关于我们",
        text_c: "联系我们",
        a_a: "",
        a_b: "",
        a_c: "",
        a_d: "",
        a_f: "",
        a_g: "",
        a_h: "",
        a_i: "",
        a_j: "公司简介",
        a_k: "质量控制",
        a_l: "高效运营",
        a_m: "数字化服务",
        a_n: "营销支持",
        a_o: "伙伴关系",
        a_p: "社会责任",
        a_q: "联系方式",
        a_r: "注册",
        a_t: "人才计划",
        a_u: "信息",
      },
      icon: {
        qr_text:
          "扫描二维码关注我们",
      },
      footer: {
        text: "Copyright ©2024 上海晓隆科技有限公司版权所有",
        text_a:
          "沪公网安备：31011402009884",
        text_b:
          "沪ICP备2022019894号-1",
        f_text_o: "网站地图",
        f_text_t: "隐私保护",
        f_text_th: "使用条款",
        f_text_f: "法律声明",
      },
    },
    brand: {
      intro_text:
        "华联配品牌自创立最初，即为斯柯达全车零部件的专业供应商，专注服务于斯柯达售后维修车辆超过20年经验。",
      intro_detail:
        "目前华联配品牌可以提供用于ŠKODA车型的产品超过15000种。同时华联配新产品会紧随斯柯达新车型上市步伐同步推出。这些都使华联配品牌成为全球70多个国家斯柯达售后市场最值得信赖的伙伴。",
    },
    productList: "产品列表",
    about: {
      company: {
        inner_h:
          "您最值得信赖的合作伙伴",
        main_dt:
          "主机厂Tier 1上游资源，销售网络遍布全国",
        main_db:
          "拥有100＋城市合伙人（前置仓）覆盖1600＋战略经销商，服务40万＋终端修理厂",
        textBox_o:
          "晓隆科技服务平台：专注主机原厂件及主机厂一级供应商同质件的正品整合，确保可溯源，造福于汽车后市场服务经销商及普通汽车用户。",
        textBox_t:
          " 晓隆以成就客户为使命，坚持创新，专注向客户提供专业的产品和服务，不断超越客户期待。同时以开放和共进的态度致力于和所有商业伙伴共赢。",
        oba: "企业使命",
        oca: "以技术创新为驱动，打造高效、透明、可信的汽车后市场供应链生态",
        oda: "致力于通过技术创新与资源整合，为汽车后市场服务经销商提供高效解决方案，赋能其业务增长；同时为普通汽车用户打造透明、便捷、高品质的汽车服务体验，构建从供应链到终端消费者的共赢生态。",
        obb: "企业愿景",
        ocb: "打造汽车后市场智慧供应链服务平台，通过先进的数字化底座和丰富的数据沉淀，实现端到端的信息流、物流、资金流的高效整合",
        odb: "我们致力于构建汽车后市场全域智慧供应链中枢，依托 AIoT（人工智能物联网）与区块链技术搭建新一代数字化基座，深度融合供应商、渠道商、服务终端及车主需求，打通从零部件生产溯源、智能仓储调度、精准物流配送到终端服务响应的全链路闭环。",
        obc: "企业理念",
        occ: "正品溯源保障，构建汽车后市场信任基石",
        odc: "公司采用F2B的商业模式，直连工厂，去除中间环节，确保每一件产品都可溯源，均为正品原件。通过技术赋能，公司推动数据标准化、商品标准化、流程标准化，助力行业信用体系建设，旨在成为全产业链的数据、服务、信用、质量标准体系的引领者和制定者。",
        obd: "核心价值观",
        ocd: "诚信为本、创新驱动、客户至上、合作共赢",
        odd: "坚持诚信经营，确保每一件产品都是正品，可追溯。鼓励技术创新、模式创新和服务创新，不断提升企业竞争力。与上下游合作伙伴建立长期稳定的合作关系，实现互利共赢。以客户需求为导向，提供个性化、定制化的解决方案。",
        obe: "社会责任",
        oce: "爱护环境、回报社会、关爱员工",
        ode: "建立职业发展双通道（技术/管理），提供全员健康保险与心理健康关怀；设立创新孵化基金，鼓励员工提案转化为实际成果。",
      },
      quality: {
        inner_h: "中 亿",
        main_d:
          "产品可溯源 质量有保证",
        tit: " 靖江中亿是国内知名的Tier 1配套工厂，核心产品是各种车门锁块、闭锁器等产品，主要给大众配套。中亿汽配是靖江中亿厂专门为后市场精心打造的车门锁品牌，车门锁产品的覆盖的大众全系列车型，及部分其他品牌热门车型。",
        right:
          "中亿年生产能力100万套，先后取得了ISO9001、ISO/TS16949等质量体系认证，确保了从原材料进厂、到产品出厂、到售后服务各环节的质量，都得到有效保证，深受用户信赖。",
        item_a: "大众全系列",
        item_b: "豪华车系列",
        item_c: "新能源系列",
      },
      efficient: {
        inner_h: "高效运营",
        main_d:
          "服务全球客户",
        text: "确保订单准时交付，只为更好的成就客户",
        inner_t:
          "公司仓库配备高度定制化的先进数字化控制系统，以确保供货准确，并准时交付。",
        inner_b:
          "晓隆在中国上海的现代化物流仓储中心，仓储面积4799m²，常备超过30,000种存货.",
        wrap_text:
          "我们通过ERP系统构建起精准、快速和完整的客户订单履约管控系统，保证了每一位客户订单的准时交付，同时最大化满足客户多样化定制需求。",
      },
      digital: {
        inner_h: "高度数字化",
        main_d:
          "让您的工作更便捷",
        zaixian:
          "晓隆 在线订购平台",
        dinghuo:
          "随时随地，订货无忧！",
        we: "我们根据客户的需求和业务形态深度定制化开发了晓隆在线订购平台。",
        kehu: "客户可以通过该平台实现订单全面管理：产品查询、产品订购、订单跟踪、活动管理及互动分享等。",
        dianzi:
          "晓隆电子目录",
        chanpin:
          "轻松创建你的晓隆产品目录",
        mulu: "您可以在晓隆网站电子目录通过多种智能查询方式，轻松找到您想了解的产品。",
        guanli:
          "产品数据管理",
        shuju:
          "TecDoc全球优秀的数据供应商",
        youxiu:
          "晓隆连续多年被TecDoc评选为全球优秀数据供应商",
        quanche:
          "作为全车零部件供应商，我们深知产品数据的准确性、完整性以及专业性对客户在企业内部应用乃至客户在本地经营时的重要性。",
        zhuanye:
          "晓隆拥有专业的产品数据管理团队，按照不同产品系统对产品数据进行整理输出并持续完善和更新。同时，为方便于客户订购且节省时间，我们对某一特定产品的关联产品信息同样进行自动匹配，供您一目了然的查询并进行必要的选择。",
      },
      social: {
        inner_h: "行业之外",
        main_d:
          "为社会创造价值",
        inner_t:
          "晓隆重视企业社会责任，愿为中国汽配市场树立典范",
        inner_b:
          "公司不但在内部运营商致力提升效率，专注主机原厂件及主机厂一级供应商同质件的正品整合，确保可溯源，造福于汽车后市场服务经销商及普通汽车用户。",
        left: "晓隆心存宏愿，愿将公司运作模式打造成为行业标杆；诚信、正直、合规，晓隆为中国汽车后市场树立典范。",
      },
      marketing: {
        inner_h:
          "全方位营销支持",
        main_d:
          "精准满足客户个性化需求",
        left_h:
          "专业的营销支持，携手客户共创未来",
        b_o: "晓隆提供客户可溯源且最优质的主机原厂件及主机厂一级供应商同质件，协助客户在汽配市场攻城略地，共同开创未来。",
        b_t: "晓隆在营销方面给与客户差异化且有竞争力的方案支持，助力客户深耕市场，站稳市场。",
        b_th: "晓隆在市场方面给予实打实的优惠政策，让在客户业绩增长同时，更能收获实实在在的收益。",
        f_r_t:
          "政策优惠，落到实处",
        b_fi: "晓隆基于共创共赢的基础思路，来设计给客户的政策，除了保证客户稳定的利润率及收益，一定程度上还能缓解客户的账面资金压力，全方位无死角地协助客户提升。",
        b_s: "晓隆给客户的优惠政策，落实到方方面面，兼顾市占率、利润率及可持续发展，是中国汽后市场领先的合作模式。",
      },
      partner: {
        inner_h: "超越合作",
        main_d:
          "我们做的更多",
        tl: "与客户建立灵活高效的信息共享机制，对瞬息万变的市场给与快速反应，与客户共创共赢",
        tr: "致力于满足客户个性化的政策及订单需求",
        bl: "通过高端完善的上游资源，满足客户对细分市场的需求，赋能客户破局增长",
        br: "晓隆与上游供应商建立成熟稳定的合作关系，助力供应商在日益激烈的汽车后市场站稳根基，共创未来",
      },
    },
    contact: {
      register: {
        s_y: "首页",
        zhu_ce: "注册",
        title: "信息",
        intro:
          "我们期待听到更多关于您和您的项目的信息。我们目前正在开展新项目。请随时填写此页面上的联系人或直接给我们发送电子邮件。干杯！",
        text_p:
          " 我们重视所有访问者的隐私，并向您保证我们将严格将这些信息用于为您服务.请查看我们的隐私政策了解详情.",
        name: "姓名:",
        company: "公司名称:",
        country: "国家:",
        city: "城市:",
        address: "地址:",
        mobile: "手机:",
        email: "电子邮箱:",
        type: "业务类型:",
        t_w: "批发商",
        t_r: "零售商",
        t_t: "贸易代理，组织",
        about:
          "你怎么知道的关于我们:",
        search:
          "搜索引擎,如百度、谷歌、360",
        others: "其他人介绍",
        look: "我看过晓隆的产品，但没有买过",
        buy: "我购买过晓隆产品",
        promotion: "展览推广",
        agree:
          "我同意晓隆的使用条件和隐私政策条款。",
        code: "验证码:",
        password: "密码:",
        confirmpassword:
          "确认密码:",
        description:
          "需求备注",
        primary: "提交",

        rules: {
          name: {
            pattern:
              "请输入正确的姓名",
            required:
              "请输入姓名",
            length:
              "长度在 2 到 15 个字符",
          },
          company: {
            pattern:
              "请输入正确的公司名称",
            required:
              "请输入公司名称",
            length:
              "长度在 3 到 15 个字符",
          },
          mobile: {
            pattern:
              "请输入正确的手机号码格式",
            required:
              "手机号/账号不能为空",
            length:
              "长度在 1 到 11 个 字符",
          },
          email: {
            pattern:
              "请输入正确的邮箱格式",
            required:
              "邮箱不能为空",
          },
          country: {
            pattern:
              "请输入正确的国家名称",
            required:
              "请输入国家名称",
            length:
              "长度在 2 到 10 个字符",
          },
          password: {
            pattern:
              "6-20位英文字母、数字或者符号(除空格)，且字母、数字和标点符号至少包含两种",
            required:
              "密码不能为空",
          },
          confirmpassword: {
            required:
              "确认密码不能为空",
          },
          description: {
            required:
              "需求备注不能为空",
          },
        },
      },

      contactWay: {
        g_s: "上海晓隆科技有限公司",
        dizhi:
          "地址：上海市嘉定区安亭镇谢春路1300弄9号",
        youbian:
          "邮编：201804",
        phone:
          "电话：021-6358 1508",
        email:
          "邮箱：{email}",
        hg_s: "河南晓隆科技有限公司",
        hdizhi:
          "地址：郑州市亚帮汽配城A区6排15号",
        hyoubian:
          "邮编：100097",
        hphone:
          "电话：0371-6632 4566",
        hemail:
          "邮箱：{hemail}",
        guanzu:
          "关注我们，让我们发生更多互动。",
      },
    },
    // map
    map: {
      news: "新闻中心",
      mediaCenter: "媒体中心",
      more: "更多",
      latestNews: "最新新闻",
    },
    // privacy
    privacy: {
      head_text:
        "隐私保护 - 晓隆科技有限公司",
      s_1: "1．我们收集哪类信息?",
      s_2: "2．保护您的隐私",
      s_3: "3．隐私权原则",
      s_4: "4、Cookies的用途",
      b_1: "通常，您能在匿名的状态下访问我们的网站并获取信息，而有些资源，需要您注册才能查看。在我们请求您提供有关信息之前，我们会解释这些信息的用途。在通常情况下，这类注册需要您提供您或您公司的一些基本信息、联系方式。我们这样做是为了使我们更好的理解您的需求，及时开展和您的联系，以便向您提供有效的服务。",
      b_2: "我们将采取适当的步骤保护您的隐私。每当您提供给我们敏感信息时，我们将采取合理的步骤保护您的敏感信息，我们也将采取合理的安全手段保护已存储的您和您公司的信息。除非根据法律或政府的强制性规定，在未得到您的许可之前，我们不会把您的任何个人信息提供给无关的第三方（包括公司或个人）。但是，如果您要求我们提供特定客户支援服务或把一些物品送交给您，我们则需要把您的姓名和地址提供给第三者如运输公司。",
      b_3: "由于您的隐私权对我们而言是相当重要的，因此，晓隆会根据下列三项原则管理涉及隐私的信息。",
      b_4: "原则1:",
      b_5: "每当晓隆需要识别您的身份与您联络时，会明确的询问所需的资料，即个人和公司资料。可能的话，晓隆会利用一些方法，确认您的个人资料的正确性与时效性。",
      b_6: "原则2:",
      b_7: "晓隆也许会因法律要求公开个人资料，或者因善意确信这样的作法对于下列各项有其必要性：",
      b_8: "（1）符合法律公告或遵守适用于晓隆科技网站的合法程序；",
      b_9: "（2）保护晓隆客户的权利或财产；",
      b_10: "（3）在紧急的情况下，为了保护晓隆及其客户的个人或公众安全。",
      b_11: "原则3:",
      b_12: "任何时候如果您认为晓隆没有遵守这些原则时，请利用电子邮件{hemail}通知我们，我们会尽一切努力，在合理适当的范围内立即改善这个问题。",
      b_13: "晓隆网站有时会使用cookies以便我们知道哪些网页受欢迎，使您在访问我们的网站时得到更好的服务。cookies不会跟踪个人信息。当您注册我们的网站时，我们可能会使用cookies。在这种情况下，会存储有用信息，使我们的网站在您再次访问我们的网站时可辨认您的身份。来自天德勤网站的cookies只能被晓隆网站读取。如果您的浏览器被设置为拒绝cookies，您仍然能够访问我们的大多数网页",
    },
    //clause
    clause: {
      head_text:
        "使用条款 - 晓隆科技有限公司",
      s_1: "1. 范围",
      s_2: "2. 晓隆网站的内容",
      s_3: "3. 使用权",
      s_4: "4. 知识产权",
      s_5: "5. 受保护网页的注册和使用",
      s_6: "6. 转引和链接",
      s_7: "7. 所有权、质量、病毒等瑕疵的责任免除",
      s_8: "8. 使用义务",
      s_9: "9. 个人数据的保护",
      p_1: " 1.1 用户使用晓隆所提供的网站时，除非中国有相关法律规定，否则应无条件地遵循这些使用条件。开始使用时，用户应接受有效的最新版本的使用条例。",
      p_2: "1.2 本通用使用条件在个案中，如产品和/ 或服务的买卖，可由进一步的条件进行补充、修改或替换。",
      p_3: "在其网站上，晓隆放置了不具有任何承诺性质的无约束力信息以及对其完整性不作保证的用于调用和下载的文件和软件。晓隆可以在任何时候未经事先通知全部或部分中断晓隆网站或更改内容。基于因特网和计算机系统的特性，晓隆不承担晓隆网站不间断可用性的责任。",
      p_4: "3.1 使用晓隆网站上可获得的信息、软件和文件应受本条款约束，若有更新信息、软件和文件，其使用应当遵守与晓隆已同意的可适用的许可条件。具体商定的许可条件优于本条款。",
      p_5: "3.2 晓隆授予用户非独占的，不可转让的权利使用可以从晓隆网站上获得的信息、软件和文件。",
      p_6: "3.3 软件仅以只读形式免费提供。用户不存在要求公开任何源代码的权利。",
      p_7: "3.4 用户在任何时候均不得出售、出租或以任何形式将信息、软件或文件提供给第三方。若无相关法律有相反规定，用户不得改变、反向开发或反向翻译软件及其文件或移除其任何部分。若备份是为将来作为本使用条件基础所需的，则用户可以为软件制作一份备份。",
      p_8: "3.5 信息、软件和文件受著作权法、国际著作权协议及其它与知识产权相关的法律和协议的保护。用户应当遵守相关法律，特别是不得移除信息、软件、文件或其复印件上任何文字数字证明、标记或著作权通告。",
      p_9: "4.1 未经晓隆事先书面许可，任何信息、商标和其他晓隆网站内容均不得被改变、复印、复制、销售、租赁、使用、补充或以任何其它方式加以使用。",
      p_10: "4.2 除使用权及其它在此明确授予的权利以外，用户并未被授予其它任何类型的权利，特别是对于公司名称或工业产权的权利，如专利、实用新型或商标的权利，晓隆亦无相应义务授予这些权利。",
      p_11: "5.1 晓隆网站的一些页面通过密码方式加以保护，只有注册用户方可进入这些网页。经晓隆注册并不产生任何权利。特别是，晓隆保留须经注册方可浏览事先可以自由浏览的网页的权利。晓隆可以在任何时候无需提供任何理由通过对访问数据加密方式撤销进入权，特别是当用户提供错误的注册信息、违反了本使用条件或与其对访问数据进行处理的审慎义务、违反了访问或使用晓隆网站的适用法律、或长时期内未使用晓隆网站。",
      p_12: "5.2 进行注册时，用户应当提供准确和正确的信息，并且应及时对任何变更进行告知。用户应当确保其提供的电子邮箱地址可以收到发给其的电子邮件。",
      p_13: "5.3 用户注册后，经审核，用户会收到一个用户名和密码（用户数据）。用户应保证不向第三方透露用户数据，并对用户数据使用的所有行为负责。在每次访问受密码保护的区域后应当退出。若用户知晓任何第三方在滥用用户数据，用户应当立即以电子邮件通知晓隆。在收到该通知并经认真审核后，晓隆将重新设置用户密码并告知用户。",
      p_14: "5.4 只要删除不是为当前合同事宜所禁止，用户可以在任何时候以书面形式要求删除任何注册。该等情况下，晓隆应当立即删除不再需要的所有用户数据和所有其它个人信息。",
      p_15: "晓隆网站可能包含转引和链接（超级链接）至第三方网站。晓隆对这些网站内容不承担任何责任，晓隆也不会将这些外部链接指向的不由晓隆实际控制的任何网页上的内容和信息变成晓隆自己的内容。对链接网站的使用由用户自行承担风险。",
      p_16: "7.1 除故意或蓄意行为外，若信息、软件和文件是免费提供的，则对有关所有权的瑕疵责任及对信息、软件和文件的质量瑕疵责任，特别是就第三方产权或著作权的正确性、无缺陷性和权利是否存在，以及完整性和可用性，均不承担责任。",
      p_17: "7.2 晓隆网站包含的信息可能在个案中(如，产品改变的原因)并未总是包含产品技术可能性的说明或一般描述。因此，产品所需的性能说明应根据个案在购买前协商一致。",
      p_18: "7.3 晓隆会尽力使网站免受各种病毒的侵害，但是晓隆不能就任何无病毒环境做出保证。在下载任何信息、软件或文件前，为保护自身安全及避免病毒进入晓隆网站，用户应当采用适当的安全措施和病毒扫描。",
      p_19: "7.4 举证责任倒置与上述规定的任何条款均无联系。",
      p_20: "8.1对于晓隆网站，用户不得",
      p_21: "对任何人特别是青少年造成损害和伤害或侵犯其隐私权；",
      p_22: "通过其使用方式违反善良风俗；",
      p_23: "侵犯工业产权或著作权或其它财产权；",
      p_24: "发送任何带有病毒程序或带有木马程序或带有可能损害软件的其它程序的内容；",
      p_25: "提供、储存或发送不允许的超级链接的内容，特别是若该等超级链接或内容违反了保密责任，或是非法的；",
      p_26: "发布广告或发送不请自来的电子邮件（即所谓“垃圾邮件”），发布与病毒、故障或类似情形无关的警告，邀请参与赌博、滚雪球游戏、连锁信、金字塔系统或其它类似的活动。",
      p_27: "8.2 晓隆可以在任何时候对访问晓隆网站的用户进行封锁，特别是当用户违反其在本条款项下的责任。 ",
      p_28: "在编辑、使用和处理用户个人资料时，晓隆将遵守可在晓隆网站上查阅到的可适用的数据保护规定。",
    },

    statute: {
      head_text:
        "法律声明 - 晓隆科技有限公司",
      p_1: "网站内容负责：",
      p_2: "信息中心 IT部",
    },
    login: {
      placeholder:
        "用户名或电子邮件地址",
      password: "密码",
      jizhu: "记住我",
      button: "登录",
      text: "欢迎来到晓隆科技",
      zhuce: "注册新账号",
    },
    talentPlan: {
      title: "人才计划",
      title_2: "在招职位",
      p_1: "上海晓隆科技有限公司是中国汽车零部件行业领先的服务型供应商，旗下拥有中亿汽配和安摩斯两大知名独立售后品牌，更有着为上汽大众、上汽通用等主机厂配套的Tier 1资源，专注主机原厂件及主机厂一级供应商同质件的正品整合，为大众、奥迪、通用、大通、荣威等车型提供质量优秀、品质可靠的原厂件、原厂同质件汽车零部件。",
      p_2: "公司立足于众多的上游Tier 1工厂资源，丰富的产品种类供应、强大的市场调研及逆向开发能力、全国3000余家头部经销商客户等多维度优势，使得晓隆的产品及影响力范围持续扩大，客户覆盖所有的重点城市，在中国汽配市场领域不断精进。",
      p_3: " 我们寻找与晓隆企业价值观和拼搏发展理念相同的伙伴，携手并进，共创未来。期待您的加入，也欢迎您联系我们的招聘部门了解我们需要的岗位招聘现况。",
      p_4: " 除了热情洋溢、奋发向上的工作氛围，舒适的办公环境，我们还为您提供：五险一金，工作午餐，职涯规划，定期培训，员工旅游。加入晓隆，一起携手共创光明的未来！",
      th_1: "开放职位",
      th_2: "工作地点",
      fot_b: "投递方式:",
      fot_d:
        "简历命名为“姓名+岗位”，投递至邮箱即可，我们将第一时间联系您！",
      hr: "HR联系邮箱：",
      phone: "电话：",
      dizhi: "地址：",
      can: "查看详情",
    },

    notFound: {
      title:
        "抱歉，您访问的页面不存在",
      backHome: "返回首页",
    },
  },
};
